import { createPortal } from 'react-dom';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function DashboardModal({
  title,
  onClose,
  onSubmit,
  onSave,
  isLoading,
  error,
  tabs,
  onRevealTab,
  children
}) {
  const handleSubmit = onSubmit || onSave;

  const handleInvalid = (event) => {
    const field = event.target;
    const panel = field.closest('[data-form-tab]');
    if (!panel || !panel.hasAttribute('hidden')) return;
    event.preventDefault();
    if (onRevealTab) onRevealTab(panel.dataset.formTab);
    window.requestAnimationFrame(() => {
      field.reportValidity();
    });
  };

  return createPortal(
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-gray-500 bg-opacity-75">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-xl max-h-[90vh] flex flex-col overflow-hidden">
        <div className="flex items-center justify-between px-4 py-4 border-b shrink-0">
          <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="flex flex-col items-center px-2 text-gray-500 hover:text-gray-700"
          >
            <XMarkIcon className="h-6 w-6" />
            <span className="text-[10px]">Close</span>
          </button>
        </div>
        <form
          onSubmit={handleSubmit}
          onInvalid={handleInvalid}
          className="flex min-h-0 flex-1 flex-col bg-gray-50"
        >
          {tabs ? <div className="shrink-0 px-4">{tabs}</div> : null}
          <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-6 py-5">
            {children}
          </div>
          <div className="shrink-0 border-t bg-white px-6 py-4">
            <div className="mb-3 min-h-[1.25rem] text-center text-sm text-red-600">
              {error || '\u00a0'}
            </div>
            <button
              type="submit"
              disabled={isLoading}
              className="w-full rounded-md bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white hover:bg-slate-800 disabled:bg-slate-400"
            >
              {isLoading ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}
